(function () {
  'use strict';

  var STORAGE_KEY = 'bmp-a11y-prefs';

  function getPrefs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
      return {};
    }
  }

  function savePrefs(prefs) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) { /* ignore */ }
  }

  function applyPrefs(prefs) {
    var html = document.documentElement;
    html.classList.remove('a11y-high-contrast', 'a11y-text-lg', 'a11y-text-xl', 'a11y-reduce-motion');
    if (prefs.highContrast) html.classList.add('a11y-high-contrast');
    if (prefs.textSize === 'lg') html.classList.add('a11y-text-lg');
    if (prefs.textSize === 'xl') html.classList.add('a11y-text-xl');
    if (prefs.reduceMotion) html.classList.add('a11y-reduce-motion');
  }

  function initToolbar() {
    var toolbar = document.getElementById('a11y-toolbar');
    if (!toolbar) return;

    var toggle = toolbar.querySelector('[data-a11y-toggle]');
    var panel = toolbar.querySelector('[data-a11y-panel]');
    var prefs = getPrefs();

    applyPrefs(prefs);

    toolbar.querySelectorAll('[data-a11y-action]').forEach(function (btn) {
      var action = btn.getAttribute('data-a11y-action');
      if (action === 'high-contrast') btn.setAttribute('aria-pressed', prefs.highContrast ? 'true' : 'false');
      if (action === 'reduce-motion') btn.setAttribute('aria-pressed', prefs.reduceMotion ? 'true' : 'false');
      if (action === 'text-lg') btn.setAttribute('aria-pressed', prefs.textSize === 'lg' ? 'true' : 'false');
      if (action === 'text-xl') btn.setAttribute('aria-pressed', prefs.textSize === 'xl' ? 'true' : 'false');
    });

    if (toggle && panel) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.setAttribute('aria-hidden', expanded ? 'true' : 'false');
      });
    }

    toolbar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-a11y-action]');
      if (!btn) return;

      var action = btn.getAttribute('data-a11y-action');
      var p = getPrefs();

      if (action === 'high-contrast') {
        p.highContrast = !p.highContrast;
        btn.setAttribute('aria-pressed', p.highContrast ? 'true' : 'false');
      } else if (action === 'reduce-motion') {
        p.reduceMotion = !p.reduceMotion;
        btn.setAttribute('aria-pressed', p.reduceMotion ? 'true' : 'false');
      } else if (action === 'text-lg') {
        p.textSize = p.textSize === 'lg' ? 'normal' : 'lg';
        toolbar.querySelectorAll('[data-a11y-action="text-lg"], [data-a11y-action="text-xl"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', p.textSize === 'lg' ? 'true' : 'false');
      } else if (action === 'text-xl') {
        p.textSize = p.textSize === 'xl' ? 'normal' : 'xl';
        toolbar.querySelectorAll('[data-a11y-action="text-lg"], [data-a11y-action="text-xl"]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', p.textSize === 'xl' ? 'true' : 'false');
      } else if (action === 'reset') {
        p = {};
        toolbar.querySelectorAll('[data-a11y-action]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
      }

      savePrefs(p);
      applyPrefs(p);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToolbar);
  } else {
    initToolbar();
  }
})();
